import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getLeccionData } from "./service/serviceCursoComprado";
import TemarioCursoComprado from "./components/TemarioCursoComprado";
import VideoPlayer from "./components/VideoPlayer";
import InformacionCursoComprado from "./components/InformacionCursoComprado/InformacionCursoComprado";
import RecursosCursosComprados from "./components/RecursosCursoComprado";
import useTokenValidation from "../../../../hooks/useTokenValidation";
import { WindowSizeContext } from "../../../../context/WindowSizeContext";
import { Oval } from "react-loader-spinner";
import UniversalIconPerfil from "../../../../components/UniversalIconoPerfil/UniversalIconPerfil";
import TooltipText from "../../../../components/TooltipText/TooltipText";

export default function CursoComprado({ scrollRef }) {
  const { tokenEntity, resetearToken, errores, notificacionRef } =
    useTokenValidation();

  const { width } = useContext(WindowSizeContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [cursoData, setCursoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("info");

  const [vIsScrollTop, setVIsScrollTop] = useState(true);

  const [vLeccionId, setVLeccionId] = useState(361);

  useEffect(() => {
    const cursoId = searchParams.get("curso_id");
    const leccionId = searchParams.get("leccion_id");

    if (!cursoId || !leccionId) {
      // Si no hay curso_id o leccion_id, redirigir a la página principal
      navigate("?f=mc", { replace: true });
    } else {
      setVLeccionId(leccionId);
    }
  }, [navigate]);

  useEffect(() => {
    if (width >= 1440 && activeTab === "temario") {
      setActiveTab("info");
    }
  }, [width]);

  useEffect(() => {
    const handleScroll = () => {
      scrollRef.current && scrollRef.current.scrollTop > 0
        ? setVIsScrollTop(false)
        : setVIsScrollTop(true);
    };

    const scrollElement = scrollRef.current;
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const mFetchGetData = () => {
    getLeccionData(tokenEntity.token, vLeccionId, searchParams.get("curso_id"))
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        // Manejo de diferentes tipos de errores basados en el código de estado
        switch (response.status) {
          case 400:
            console.log("Datos inválidos");
            throw new Error("ERR_VALIDATION");

          case 401:
            console.log("Acceso denegado");
            throw new Error("ERR_UNAUTHORIZED");
          case 403:
            console.log("Acceso denegado");
            navigate("?f=mc", { replace: true });
            throw new Error("ERR_UNAUTHORIZED");
          case 404:
            console.log("Acceso denegado");
            return response.json();
          //throw new Error("ERR_UNAUTHORIZED");

          case 500:
            console.log("Error al obtener categorias");
            throw new Error("ERR_SERVER");

          default:
            console.log("Error inesperado");
            throw new Error("ERR_UNKNOWN");
        }
      })
      .then((result) => {
        console.log(result);
        switch (result["detail"]["acción"]) {
          case "VERIFICAR_LECCION":
            console.log("Holas");
            break;

          default:
            setCursoData(result);
            break;
        }
      })
      .catch((error) => {
        // Separar las propiedades del error
        setError(error);
        const { message } = error;
        if (message !== "ERR_ME") {
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!tokenEntity.isValidando) {
      if (vLeccionId) {
        mFetchGetData();
      }
    }
  }, [vLeccionId, tokenEntity.isValidando]);

  function actualizarLeccion(vIsTerminado = false) {
    var data = cursoData.detail.datos.CURSO_TEMARIO.secciones;
    let leccionActualizada = false;

    for (let i = 0; i < data.length; i++) {
      const seccion = data[i];

      for (let j = 0; j < seccion.lecciones.length; j++) {
        const leccion = seccion.lecciones[j];

        if (leccion.estado === "en curso") {
          // Marcar actual como terminada
          leccion.estado = "terminado";
          leccion.terminado = true;

          if (!vIsTerminado) {
            // Ver si hay una siguiente lección en la misma sección
            if (j + 1 < seccion.lecciones.length) {
              seccion.lecciones[j + 1].estado = "en curso";
              seccion.lecciones[j + 1].terminado = false;
            } else {
              // Buscar la siguiente lección en la siguiente sección
              for (let k = i + 1; k < data.length; k++) {
                if (data[k].lecciones.length > 0) {
                  data[k].lecciones[0].estado = "en curso";
                  data[k].lecciones[0].terminado = false;
                  break;
                }
              }
            }
          }

          leccionActualizada = true;
          break;
        }
      }

      if (leccionActualizada) break;
    }

    setCursoData({
      ...cursoData,
      detail: {
        ...cursoData.detail,
        datos: {
          ...cursoData.detail.datos,
          CURSO_TEMARIO: {
            ...cursoData.detail.datos.CURSO_TEMARIO,
            secciones: data,
          },
        },
      },
    });
  }

  if (loading) {
    return (
      <Oval
        visible={true}
        height="50"
        width="50"
        color="#fff"
        secondaryColor="#f5f5f5"
        ariaLabel="oval-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    ); // O spinner si prefieres algo más visual
  }

  if (error) {
    return <div>Error al cargar los datos. Intenta nuevamente.</div>;
  }
  const leccionesTerminadas =
    cursoData.detail.datos.CURSO_TEMARIO.lecciones_terminadas; // "2/14"
  const [numerador, denominador] = leccionesTerminadas.split("/");

  // Obtener el nombre de la lección correspondiente al siguiente_leccion_id
  const siguienteLeccionId =
    cursoData.detail.datos.CURSO_INFORMACION.siguiente_leccion_id;
  const secciones = cursoData.detail.datos.CURSO_TEMARIO.secciones;

  let leccionNombre = "";
  secciones.forEach((seccion) => {
    const leccion = seccion.lecciones.find(
      (leccion) => leccion.leccion_id === siguienteLeccionId
    );
    if (leccion) {
      leccionNombre = leccion.leccion_nombre.split(":")[0]; // Solo la parte antes de ":"
    }
  });

  /*
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (!queryParams.has("lcc_id")) {
      navigate("?f=mc", { replace: true });
    }
  }, [location, navigate]);
  */

  const updateLessonStates = (secciones) => {
    let inProgressSet = false; // Flag to mark if "en curso" has been assigned
    secciones.forEach((seccion) => {
      seccion.lecciones.forEach((leccion) => {
        if (leccion.terminado) {
          leccion.estado = "terminado";
        } else if (!inProgressSet) {
          leccion.estado = "en curso";
          inProgressSet = true; // Mark that "en curso" has been assigned
        } else {
          leccion.estado = "sin empezar";
        }
      });
    });
  };

  const cambiarLeccionId = (nuevoId) => {
    // Crea una instancia de URLSearchParams con los parámetros actuales
    const searchParams = new URLSearchParams(location.search);
    // Establece el nuevo valor para "leccion_id"
    searchParams.set("leccion_id", nuevoId);
    // Actualiza la URL sin recargar la página
    navigate(`${location.pathname}?${searchParams.toString()}`);
    window.location.reload();
  };
  updateLessonStates(cursoData.detail.datos.CURSO_TEMARIO.secciones);

  const siguiente_leccion_id =
    cursoData.detail.datos.CURSO_INFORMACION.siguiente_leccion_id;
  let nextLesson = null;

  // Buscamos en todas las secciones la lección que tenga ese ID
  cursoData.detail.datos.CURSO_TEMARIO.secciones.forEach((seccion) => {
    const found = seccion.lecciones.find(
      (leccion) => leccion.leccion_id === siguiente_leccion_id
    );
    if (found) nextLesson = found;
  });

  return (
    <>
      <div
        data-figma-id="810:15668"
        class="header-style"
        style={{
          backgroundColor: vIsScrollTop ? "transparent" : "#1d1d1d",
        }}
      >
        <p data-figma-id="810:15669" class="header-texto">
          Mis cursos
        </p>
        <div data-figma-id="810:15670" class="header-iconos">
          <i class="fi fi-rs-bell bell-1-2"></i>
          <UniversalIconPerfil />
        </div>
      </div>
      <div data-figma-id="1622:16242" class="curso-comprado-info">
        <div data-figma-id="1621:15228" class="curso-comprado-info-1">
          <div data-figma-id="1621:15229" class="curso-comprado-info-1-header">
            <div
              data-figma-id="1621:15230"
              class="curso-comprado-titulo-profesor"
            >
              <p
                data-figma-id="1621:15231"
                class="curso-comprado-titulo-profesor-texto"
              >
                {cursoData.detail.datos.CURSO_INFORMACION.curso}
              </p>
              <div data-figma-id="1621:15232" class="curso-comprado-profesor">
                <p
                  data-figma-id="1621:15234"
                  class="curso-comprado-profesor-texto"
                >
                  {cursoData.detail.datos.CURSO_INFORMACION.maestro}
                </p>
              </div>
            </div>
            {/*
            <div data-figma-id="1622:15913" class="boton-evaluacion">
              <i class="fi fi-rr-file-question pregunta-de-archivo-1"></i>
              <p data-figma-id="1622:15915" class="boton-evaluacion-texto">
                Evaluación
              </p>
            </div>
            */}
          </div>
          <VideoPlayer
            actualizarLeccion={actualizarLeccion}
            vLeccionId={vLeccionId}
            vLeccion={cursoData.detail.datos.CURSO_INFORMACION}
          />
          <div data-figma-id="1621:15243" class="curso-comprado-video-info">
            <div
              data-figma-id="1621:15244"
              class="curso-comprado-video-info-header"
            >
              <div
                data-figma-id="1621:15245"
                class="curso-comprado-video-info-titulos"
              >
                <div
                  data-figma-id="1621:15246"
                  class="curso-comprado-video-info-titulo"
                >
                  <i class="fi fi-rr-book-alt libro-alternativo-5"></i>
                  <p
                    data-figma-id="1621:15248"
                    class="curso-comprado-video-info-titulo-texto"
                  >
                    {
                      cursoData.detail.datos.CURSO_INFORMACION
                        .leccion_actual_nombre
                    }
                  </p>
                </div>
                {/*}
                <p
                  data-figma-id="1621:15249"
                  class="curso-comprado-video-info-leccion-texto"
                >
                  {`Lección ${cursoData.detail.datos.CURSO_INFORMACION.leccion_actual_numero}`}
                </p>
                */}
              </div>
              {nextLesson && (
                <TooltipText
                  vText="Debes completar la lección"
                  data-figma-id="1622:15907"
                  className={
                    nextLesson.estado === "sin empezar"
                      ? "boton-leccion-no-autorizada"
                      : "boton-leccion"
                  }
                  onClick={() => {
                    // Solo ejecutamos si el estado no es "sin empezar"
                    if (nextLesson.estado !== "sin empezar") {
                      cambiarLeccionId(siguiente_leccion_id);
                    }
                  }}
                >
                  <p data-figma-id="1622:15908" class="boton-leccion-texto">
                    {leccionNombre}
                  </p>
                  <i class="fi fi-rs-angle-right angle-right-1-1"></i>
                </TooltipText>
              )}
            </div>
            <div
              data-figma-id="1621:15251"
              class="curso-comprado-video-info-general"
            >
              <div
                data-figma-id="1621:15252"
                class="curso-comprado-video-info-general-contenido"
              >
                <div
                  data-figma-id="1621:15253"
                  className="curso-comprado-video-info-general-menu"
                >
                  <div
                    data-figma-id="1622:15882"
                    className={
                      activeTab === "info" ? "boton-cursos-3" : "boton-cursos-4"
                    }
                    onClick={() => setActiveTab("info")}
                  >
                    <p
                      data-figma-id="1622:15883"
                      className="mis-cursos-subtitulo-texto-2"
                    >
                      Información del curso
                    </p>
                  </div>
                  <div
                    data-figma-id="1622:15880"
                    className={
                      activeTab === "recursos"
                        ? "boton-cursos-3"
                        : "boton-cursos-4"
                    }
                    onClick={() => setActiveTab("recursos")}
                  >
                    <p
                      data-figma-id="1622:15881"
                      className="mis-cursos-subtitulo-texto-2"
                    >
                      Recursos
                    </p>
                  </div>
                  {width <= 1439 && (
                    <div
                      data-figma-id="1622:15878"
                      className={
                        activeTab === "temario"
                          ? "boton-cursos-3"
                          : "boton-cursos-4"
                      }
                      onClick={() => setActiveTab("temario")}
                    >
                      <p
                        data-figma-id="1622:15879"
                        className="mis-cursos-subtitulo-texto-2"
                      >
                        Temario
                      </p>
                    </div>
                  )}
                </div>
                {activeTab === "info" && (
                  <div data-figma-id="1621:15801" class="apartados-video">
                    <InformacionCursoComprado cursoData={cursoData} />
                  </div>
                )}
                {activeTab === "temario" && (
                  <div data-figma-id="1621:15602" class="temario-movil">
                    <TemarioCursoComprado
                      cursoData={cursoData}
                      numerador={numerador}
                      denominador={denominador}
                    />
                  </div>
                )}

                {activeTab === "recursos" && (
                  <RecursosCursosComprados
                    cursoData={cursoData}
                    getToken={tokenEntity.token}
                  />
                )}
              </div>
              <div class="certificado-progreso"></div>
              {/*
              <div data-figma-id="1622:15895" class="certificado-progreso">
                <div
                  data-figma-id="1622:15896"
                  class="certificado-progreso-info"
                >
                  <div
                    data-figma-id="1622:15897"
                    class="certificado-progreso-icono"
                  >
                    <div data-figma-id="1622:15905" class="diploma-2-2">
                      <i
                        className="fi fi-rr-diploma"
                        style={{ color: "white" }}
                      ></i>
                    </div>
                  </div>
                  <div
                    data-figma-id="1622:15899"
                    class="certificado-progreso-textos"
                  >
                    <p
                      data-figma-id="1622:15900"
                      class="certificado-progreso-texto-1"
                    >
                      Certificado
                    </p>
                    <p
                      data-figma-id="1622:15901"
                      class="certificado-progreso-texto-2"
                    >
                      En Progreso
                    </p>
                  </div>
                </div>
                <div
                  data-figma-id="1622:15902"
                  class="certificado-progreso-barra"
                >
                  <div
                    data-figma-id="1622:15903"
                    class="certificado-progreso-barra-1"
                    style={{
                      width: `${cursoData.detail.datos.CURSO_INFORMACION.progreso_certificado}`,
                    }}
                  ></div>
                </div>
              </div>
              */}
            </div>
          </div>
        </div>
        <div className="temario">
          <TemarioCursoComprado
            cursoData={cursoData}
            numerador={numerador}
            denominador={denominador}
          />
        </div>
      </div>
    </>
  );
}
